import React, { Component } from 'react';
import { ReactMic as Visualizer } from 'react-mic';
import { getSpeechBlob, getSpeakers } from './api';
import Wave from './components/Wave';
import Spinner from 'react-bootstrap/Spinner';

class Listen extends Component {
    textAreaCharcterLimit = 300;

    constructor(props) {
        super(props);

        this.state = {
            speaker: '',
            speakerIdx: "",
            speechText: "",
            play: false,
            blob: undefined,
            audioFilePath: "",
            displayWav: false,
            prevAudioSpeechText: "",
            prevSpeaker: "",
            prevSpeakerIdx: "",
            fetchingAuidoResponse: false,
            speakerList: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSpeakerIdxChange = this.handleSpeakerIdxChange.bind(this);
        this.handleSpeechTextChange = this.handleSpeechTextChange.bind(this);
    }

    componentDidMount() {
        this.getSpeakers()
    }

    render() {
        return (
            <div id="pageListen">
                <div><h1 className="customH1">Text to Speech</h1></div>
                <div>
                    <textarea id="listenTextArea" rows="5" columns="200" placeholder="Enter the text to play" autoFocus={true} value={this.state.speechText} onChange={this.handleSpeechTextChange} maxLength={this.textAreaCharcterLimit}>
                    </textarea>
                </div>
                <span className="float-right">Characters left: {this.textAreaCharcterLimit - this.state.speechText.length}</span>
                <br />
                <div className="speakerInfoContainer">
                    <div className="speakerNameSelect">
                        <div>
                            <span className="customSpan"><h2 className="customH2">Speaker</h2></span>
                        </div>
                        <div className="row justify-content-between align-items-center">
                            <select value={this.state.speaker} onChange={this.handleChange}>
                                {this.state.speakerList.map(({ value, label }, index) => <option key={value} value={value} >{label}</option>)}
                            </select>
                            <div className={`${this.state.speaker !== "default_male_4" ? 'd-none' : ''}`}>
                                <span>
                                    &nbsp; &nbsp; &nbsp;
                                    < input type="number" id="speakerIdx" name="speakerIdx" min="0" max="109" data-toggle="tooltip" title="Speaker ID (0-109)" value={this.state.speakerIdx} onChange={this.handleSpeakerIdxChange}></input >
                                    &nbsp;
                                    <i class="fa fa-sm fa-question-circle" aria-hidden="true" title="Enter a speaker ID (ranging from 0 to 109)"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <div className="wave-container" id="container">
                    {/* {!this.state.audioFilePath ? null : <audio controls src={this.state.audioFilePath}> </audio>} */}
                    {this.state.displayWav ? this.renderWave() : this.renderVisualizer()}
                </div>
                <div className="playButtonContainer">
                    <button
                        id="getSpeechBtn"
                        onClick={this.getSpeech}
                        disabled={this.state.speechText === "" || (this.state.speechText === this.state.prevAudioSpeechText && this.state.speaker === this.state.prevSpeaker && this.state.speakerIdx === this.state.prevSpeakerIdx) || this.state.fetchingAuidoResponse || (this.state.speaker === "default_male_4" && (this.state.speakerIdx === "" || parseInt(this.state.speakerIdx) < 0 || parseInt(this.state.speakerIdx) > 109))}
                    >
                        {!this.state.fetchingAuidoResponse ? <i className="fas ibutton fa-cog" /> :
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        }
                        {!this.state.fetchingAuidoResponse ? null : <span>&nbsp; &nbsp; &nbsp;</span>}
                        {!this.state.fetchingAuidoResponse ? "Get Speech" : "Loading ..."}


                    </button>

                    <button
                        id="btn_Play"
                        data-title="Play audio"
                        disabled={this.state.blob === undefined}
                        className="btn btn-play"
                        onClick={!this.state.play ? this.playWav : this.stopWav}
                    >
                        <i className={`fas ibutton ${!this.state.play ? 'fa-play' : 'fa-stop-circle'}`} />
                        {!this.state.play ? 'Play' : 'Stop'}
                    </button>
                </div>
            </div >
        )
    }

    handleChange(event) {
        this.setState({ speaker: event.target.value });
    }

    handleSpeakerIdxChange(event) {
        this.setState({ speakerIdx: event.target.value });
    }

    handleSpeechTextChange(event) {
        this.setState({ speechText: event.target.value });
    }

    getSpeakers = () => {
        getSpeakers()
            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    this.setState({
                        speakerList: res.data.speakers_list,
                        speaker: res.data.default_speaker.value
                    });
                }
                else {
                    this.showError(null, 'We were unable to get the speakers. Please Try Again.');
                }
            }).catch(err => this.showError(err));

    }

    getSpeech = () => {
        this.setState({
            audioFilePath: "",
            blob: undefined,
            fetchingAuidoResponse: true
        });

        this.shouldDisplayWav(false);

        getSpeechBlob(this.state.speaker, this.state.speakerIdx, this.state.speechText)
            .then(res => {
                if (res.success) {
                    var blob = new Blob(res.data, { type: 'audio/wav' });
                    var url = window.URL.createObjectURL(blob)

                    this.setState({
                        audioFilePath: url,
                        blob: blob,
                        prevAudioSpeechText: this.state.speechText,
                        prevSpeaker: this.state.speaker,
                        prevSpeakerIdx: this.state.speakerIdx,
                        fetchingAuidoResponse: false
                    });

                    this.shouldDisplayWav(true);
                }
                else {
                    this.setState({
                        fetchingAuidoResponse: false
                    });
                    this.showError(null, 'We were unable to get the audio file. Please Try Again.');
                }
            }).catch(err => this.showError(err));
    }

    playWav = () => this.setState({ play: true });

    stopWav = () => this.setState({ play: false });

    shouldDisplayWav = bool => this.setState({ displayWav: bool });

    renderWave = () => (
        <Wave
            className="wavedisplay"
            waveColor="rgba(255, 255, 255, 0.15)"
            progressColor="#88dcfe"
            blob={this.state.blob}
            play={this.state.play}
            onFinish={this.stopWav}
        />
    );

    renderVisualizer = () => (
        <Visualizer
            className="wavedisplay"
            // record={true}
            backgroundColor={"#14161e"}
            strokeColor={"#88dcfe"}
        />
    );

    showError = (err, message) => {
        if (err) {
            console.error(err);
        }

        this.setState({
            fetchingAuidoResponse: false
        });

    }
}

export default Listen;


// WEBPACK FOOTER //
// ./src/App/Listen.js